var Enum = Enum || {};

Enum.MEEDY.SECOND_DIAGNOSIS_STATUS = {
	UNSEND: 'UNSEND',
	PRE_VALIDATED: 'PRE_VALIDATED',
	WAITING_FOR_PAYMENT: 'WAITING_FOR_PAYMENT',
	VALIDATED: 'VALIDATED',
	SEND_TO_PHYSICIAN: 'SEND_TO_PHYSICIAN',
	DONE: 'DONE',
	CANCELLED: 'CANCELLED',
	REJECTED_BY_CONSULTANT: 'REJECTED_BY_CONSULTANT',
	REJECTED_BY_PHYSICIAN: 'REJECTED_BY_PHYSICIAN',
	REJECTED_BY_PHYSICIAN_INCOMPETENCE: 'REJECTED_BY_PHYSICIAN_INCOMPETENCE',
	IN_PROGRESS: 'IN_PROGRESS',
	MISSING_DATA: 'MISSING_DATA',
	REJECTED: 'REJECTED'
};

Object.freeze(Enum.MEEDY.SECOND_DIAGNOSIS_STATUS);

